import { useCallback, useState } from 'react'
import { useGenerateFilledPdfMutation } from '@/core/services/form'

export function useGenerateFilledPdf() {
    const [generatingPdfId, setGeneratingPdfId] = useState<string | null>(null)
    const [generateFilledPdf] = useGenerateFilledPdfMutation()

    const handleGeneratePdf = useCallback(async (submissionId: string) => {
        setGeneratingPdfId(submissionId)
        try {
            const url = await generateFilledPdf(submissionId).unwrap()
            window.open(url, '_blank')
        } catch (err) {
            console.error('Failed to generate PDF', err)
        } finally {
            setGeneratingPdfId(null)
        }
    }, [generateFilledPdf])

    return {
        handleGeneratePdf,
        generatingPdfId,
        isGeneratingPdf: generatingPdfId !== null,
    }
}
